module.exports = __webpack_public_path__ + "static/media/SALLE_A_MANGER_COMMUN.6b36d93d.jpg";